import { getPageLastModified } from "../config/pageLastModified";

const normalizePath = path => {
  const withoutLanguage = (path || "/").replace(/^\/[a-z]{2}(?=\/|$)/, "") || "/";
  return withoutLanguage.endsWith("/") ? withoutLanguage : `${withoutLanguage}/`;
};

export const isProductOrCategoryPage = path => Boolean(getPageLastModified(normalizePath(path)));

export const withCurrentYearInTitle = (title, pageName) => {
  if (!title || !isProductOrCategoryPage(pageName)) {
    return title;
  }

  const lastModified = getPageLastModified(pageName);
  const currentYear = lastModified?.slice(0, 4);

  if (!currentYear) {
    return title;
  }
  const titleWithUpdatedYear = title.replace(/\b20\d{2}\b/g, String(currentYear));

  return titleWithUpdatedYear.includes(String(currentYear)) ? titleWithUpdatedYear : `${titleWithUpdatedYear} | ${currentYear}`;
};

const isWebPage = type => type === "WebPage" || type === "FAQPage" || (Array.isArray(type) && type.some(isWebPage));

export const withDateModified = ({ schema, canonicalUrl, title, dateModified }) => {
  if (!schema || !canonicalUrl || !dateModified) {
    return schema;
  }

  const graph = schema["@graph"] || [Object.fromEntries(Object.entries(schema).filter(([key]) => key !== "@context"))];
  let hasWebPage = false;
  const updatedGraph = graph.map(node => {
    if (!isWebPage(node?.["@type"])) {
      return node;
    }

    hasWebPage = true;
    return { ...node, dateModified, lastReviewed: dateModified };
  });

  if (!hasWebPage) {
    updatedGraph.push({
      "@type": "WebPage",
      "@id": canonicalUrl,
      url: canonicalUrl,
      name: title,
      dateModified,
      lastReviewed: dateModified
    });
  }

  return {
    "@context": schema["@context"] || "https://schema.org",
    "@graph": updatedGraph
  };
};
